import { compose } from 'recompose';
import { addProps } from 'utils/recompose';
import styles from './styles.module.scss';
import { addIntlProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import messages from './messages';

const priorityDot = ({ priority }) => {
  if (priority === "2") {
    return styles.dotRed
  } else if (priority === "3") {
    return styles.dotYellow
  } else if (priority === "4") {
    return styles.dotBlue
  } else {
    return styles.dotGrey
  }
}

export default compose(
  injectIntl,
  addIntlProps({ messages, propNames: ['priorityLabel'] }),
  addProps({ priorityDot }),
);

